import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-drop-down-item',
  templateUrl: './drop-down-item.component.html',
  styleUrls: ['./drop-down-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropDownItemComponent {
  // e.x. 'upload-arrow-in-circle.svg; icon-size-1p5'
  @Input() iconNameAndStyling: string;
  @Input() disabled = false;
  @Input() text = '';
  @Input() menuItemClass = '';
  @Output() itemClick = new EventEmitter<void>();

  itemClickEmitter(): void {
    if (this.disabled) {
      return;
    }

    this.itemClick.emit();
  }
}

